/* eslint-disable */
import config from "../../config/customer.api";
import { appInsights } from "../shared/applicationInsights";
import { Request } from "../shared/base.requests";
import {ReferralProgramHistoryStatus} from '@/shared/enums/referral.enum.js'

const recommendFriendModule = {
  namespaced: true,
  state: {
    history: [],
    historyCount: null,
    historyStatuses: [],
    historyLoaded: false,
    mainInfo: {
      title: "",
      subtitle: "",
      disclaimerTitle: "",
      stepInfos: [],
    },
    smsMessage: "",
    page: 2,
    pageEnum: {
      share: 1,
      histroy: 2,
    },
    terms: null,
    sharedLinkData:{
      link:null, 
      title: null,
      contactId: null
    }
  },
  mutations: {
    setRecommendFriendHistory(state, payload) {
      state.history = payload;
    },
    setInfo(state, payload) {
      state.mainInfo = payload;
    },
    setPage(state, payload) {
      state.page = payload;
    },
    // setMessageForSms(state, payload) {
    //   state.smsMessage = payload;
    // },
    setHistoryStatuses(state, payload) {
      state.historyStatuses = Object.entries(payload).map(([key, val])=>({id:+key, text: val}));
    },
    setTerms(state, payload){
      state.terms = payload
    },
    setShareLinkData(state, payload){
      state.sharedLinkData = payload
    },
    setHistoryLoaded(state, payload){
      state.historyLoaded = payload
    },
    removeReferralFromHistory(state, payload){
      state.history = state.history.filter(x=>x.referralHistoryId !== payload)
    },
    updateReferalInHistory(state, payload){
      let index = state.history.findIndex(x=>x.referralHistoryId === payload.referralHistoryId)
      if(index === -1){
        console.error("referral not found");
        return
      }
      const [firstName, lastName] = payload.fullName.split(' ');
      Object.assign(state.history[index], {
        firstName, lastName, referralContactPhone: payload.phone
      });
    },
    setRecommendFriendHistoryCount(state, count){
      state.historyCount = count
    }
  },
  actions: {
    loadRecommendFriendHistory: function(context, filterValue) {
      context.commit("setHistoryLoaded", false);
      return new Promise((resolve, reject) => {
        filterValue = filterValue || 0
        let apiUrl = config.recommendFriendHistory(filterValue || 0);
        Request.get(apiUrl)
          .then((response) => {
            context.commit("setRecommendFriendHistory", response.model);
            if(filterValue === 0){
              context.commit("setRecommendFriendHistoryCount", response.model.length);
            }
            
            resolve();
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId },
            });
            appInsights.flush();

            console.error("loadRecommendFriends failed", error);
            reject();
          })
          .finally(()=>{
           context.commit("setHistoryLoaded", true);
          });
      });
    },
    getInfo: function(context) {
      return new Promise((resolve, reject) => {
        let apiUrl = config.getReferralInfo;
        Request.get(apiUrl)
          .then((response) => {
            context.commit("setInfo", response);
            resolve();
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId },
            });
            appInsights.flush();
            console.error("recommendFriendShare failed", error);
            reject();
          });
      });
    },
    setPage: function(context, payload) {
      context.commit("setPage", payload);
    },
    invite: function(context, payload) {
      return new Promise((resolve, reject) => {
        let apiUrl = config.recommendFriendShare;
        Request.post(apiUrl, payload)
          .then((response) => {
            context.dispatch('loadRecommendFriendHistory');
            if(!response.success){
             return reject('Server error');
            }
            resolve();
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: {
                apiUrl: apiUrl,
                data: payload,
                accessId: localStorage.accessId,
              },
            });
            appInsights.flush();
            reject(error);
          });
      });
    },
    loadHistoryStatuses(context) {
      let url = config.recommendFriendHistoryStatuses;
      return new Promise((resolve, reject) => {
        Request.get(url)
          .then((response) => {
            context.commit("setHistoryStatuses", response);
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getTerms(context){
      return new Promise((resolve, reject)=>{
        let url = config.recommendFriendTerms
        Request.get(url).then((res)=>{
          context.commit('setTerms', res.terms)
          resolve()
        }).catch((err)=>reject(err))
      })
    },
    getShareLink(context){
      return new Promise((resolve, reject)=>{
        let url = config.recommendFriendShageLink
        Request.get(url).then((res)=>{
          context.commit('setShareLinkData', res)
          resolve()
        }).catch((err)=>reject(err))
      })
    },
    sendSharedLink(context, data){
      return new Promise((resolve, reject)=>{
        let url = config.recommendFriendSendShareLink
        Request.post(url, data).then((res)=>{
          resolve()
        }).catch((err)=>reject(err))
      })
    },
    addReferral(context, data){
      return new Promise((resolve, reject)=>{
        let url = config.addReferral
        Request.post(url, data).then((res)=>{
          resolve(res)
        }).catch((err)=>reject(err))
      })
    },
    editReferral(context, data){
      return new Promise((resolve, reject)=>{
        const url = config.editReferral
        Request.post(url, data).then((res)=>{
          if(res.success){
            context.commit("updateReferalInHistory", data);
          }
          resolve(res)
        }).catch((err)=>reject(err))
      })
    },
    deleteReferral(context, historyId){
      return new Promise((resolve, reject)=>{
        const url = config.deleteReferral
        Request.delete(url, {
          referralHistoryId :historyId
        }).then((res)=>{
          if(res.success){
            context.commit("removeReferralFromHistory", historyId);
          }
          resolve(res)
        }).catch((err)=>reject(err))
      })
    },
    getReferralMessage(context, data){
      return new Promise((resolve, reject)=>{
        const url = config.getReferralMessage;
        Request.get(url, {referralCode: data}).then((res)=>{
          resolve(res)
        }).catch((err)=>reject(err))
      })
    },
    sendSmsAction(context, data){
      return new Promise((resolve, reject)=>{
        const url = config.sendSmsAction;
        Request.post(url, null , {referralCode: data}).then((res)=>{
          resolve(res)
        }).catch((err)=>reject(err))
      })
    }
  },
  getters: {
    history: (state) => state.history,
    title: (state) => state.mainInfo.title,
    description: (state) => state.mainInfo.subTitle,
    disclaimer: (state) => state.mainInfo.disclaimerTitle,
    steps: (state) => state.mainInfo.stepInfos,
    statuses: (state) => state.historyStatuses.filter(x=>x.id !== ReferralProgramHistoryStatus.None),
    terms: (state) => state.terms,
    sharedLinkData: (state) => state.sharedLinkData,
    referralProgramType: (state) => state.mainInfo.referralProgramId,
    historyLoaded: (state) => state.historyLoaded,
    textMessage: (state) => state.mainInfo.dbcTextMessageApp
  },
};

export default recommendFriendModule;



// WEBPACK FOOTER //
// ./scripts/src/store/recommend.friend.module.js